import { z } from 'zod';

export const ActionLogArea = {
  CaseUserAction: 'CaseUserAction',
  CaseAdviserAction: 'CaseAdviserAction',
} as const;
export type ActionLogArea = (typeof ActionLogArea)[keyof typeof ActionLogArea];

export const ActionLogAreaSchema = z.union([
  z.literal(ActionLogArea.CaseUserAction),
  z.literal(ActionLogArea.CaseAdviserAction),
]);

export const ActionLogStatus = {
  New: 'New',
  InProgress: 'InProgress',
  Complete: 'Complete',
  Failed: 'Failed',
  Cancelled: 'Cancelled',
  Waiting: 'Waiting',
} as const;

export const ActionLogType = {
  ExperianOpenBanking: 'ExperianOpenBanking',
  Digidentity: 'Digidentity',
  ExperianCredit: 'ExperianCredit',
  ExperianCreditSearch: 'ExperianCreditSearch',
  FactFind: 'FactFind',
} as const;

export const ActionLogStatusSchema = z.union([
  z.literal(ActionLogStatus.New),
  z.literal(ActionLogStatus.InProgress),
  z.literal(ActionLogStatus.Complete),
  z.literal(ActionLogStatus.Failed),
  z.literal(ActionLogStatus.Cancelled),
  z.literal(ActionLogStatus.Waiting),
]);

export const ActionLogSetStatusRequestSchema = z.object({
  organisationId: z.string(),
  actionId: z.string(),
  newStatus: ActionLogStatusSchema,
  newMessage: z.string(),
  userId: z.number().int(),
});
export type ActionLogSetStatusRequest = z.infer<typeof ActionLogSetStatusRequestSchema>;

export const ActionStatusUpdateResponseSchema = z.boolean();
export type ActionStatusUpdateResponse = z.infer<typeof ActionStatusUpdateResponseSchema>;

export type ActionLogStatusType = (typeof ActionLogStatus)[keyof typeof ActionLogStatus];

export const ActionLogSearchRequestSchema = z.object({
  organisationId: z.string(),
  area: z.string(),
  externalReference1: z.string(),
  externalReference2: z.string(),
  actionType: z.string().optional(),
});
export type ActionLogSearchRequest = z.infer<typeof ActionLogSearchRequestSchema>;

export type ActionLogType = (typeof ActionLogType)[keyof typeof ActionLogType];
export const ActionLogTypeSchema = z.union([
  z.literal(ActionLogType.ExperianOpenBanking),
  z.literal(ActionLogType.Digidentity),
  z.literal(ActionLogType.ExperianCredit),
  z.literal(ActionLogType.ExperianCreditSearch),
  z.literal(ActionLogType.FactFind),
]);

export const ActionLogItemSchema = z.object({
  organisationId: z.string().uuid(),
  actionId: z.string().uuid(),
  actionType: ActionLogTypeSchema,
  externalReference1: z.string().optional(),
  externalReference2: z.string().optional(),
  status: ActionLogStatusSchema,
  message: z.string().optional().nullable(),
  area: ActionLogAreaSchema,
  actionedBy: z.string().nullable(),
  timestamp: z.string(),
});
export type ActionLogItem = z.infer<typeof ActionLogItemSchema>;

export const ActionLogSearchResponseSchema = z.array(ActionLogItemSchema);
export type ActionLogSearchResponse = z.infer<typeof ActionLogSearchResponseSchema>;

export const CreateActionLogRequestSchema = z.object({
  organisationId: z.string(),
  area: z.string(),
  actionType: ActionLogTypeSchema,
  externalReference1: z.string(),
  externalReference2: z.string(),
  userId: z.number().int(),
  message: z.string(),
  allowDuplicates: z.boolean(),
});
export type CreateActionLogRequest = z.infer<typeof CreateActionLogRequestSchema>;

export const CreateActionLogResponseSchema = z.string().uuid();
export type CreateActionLogResponse = z.infer<typeof CreateActionLogResponseSchema>;
